
import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { IMAGE_VARIANT } from '@/common/const'

export default Vue.extend({
  name:'CategoryList',
  components:{
    BaseImage
  },
  props: {
    category: {
      type: Object as () => ProductCategory,
      required: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    childCategoryList(): ProductCategory[] {
      return this.category.child_categories.length ? this.category.child_categories : [this.category]
    },
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.CATEGORY_ICON_MAIN
    }
  }
})
